import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ArtistDetailPresenter from './ArtistDetailPresenter';
import { useScrollTop } from '../../hooks';
import { artist } from '../../api';

import { ARTIST_DETAILS } from '../../artist';

const artistInitState = null; // []
const worksInitState = null;
const menuListInitState = [];

const ArtistDetailContainer = () => {
  const { id } = useParams();

  const [artist, setArtist] = React.useState(artistInitState);
  const [works, setWorks] = React.useState(worksInitState);
  const [menuList, setMenuList] = React.useState(menuListInitState);

  const navigate = useNavigate();

  const onClickBack = () => navigate(-1);
  const onClickLink = (link) => {
    if (link) {
      window.open(link, '_blank', 'noopener,noreferrer');
    }
  };

  React.useEffect(() => {
    const fetchData = async () => {
      const artistDetail = await ARTIST_DETAILS[id]; // 비동기 데이터 로딩
      setArtist(artistDetail);
      setWorks(artistDetail.works);

      const worksKeys = Object.keys(artistDetail.works).map(key => 
        key.charAt(0).toUpperCase() + key.slice(1).toLowerCase()
      );
      setMenuList(worksKeys);
    };
    fetchData();
  }, [id]);

  useScrollTop();

  if (!artist || !works) return null;
  
  return (
    <ArtistDetailPresenter 
      artist={artist} 
      works={works} 
      menuList={menuList} 
      onClickBack={onClickBack} 
      onClickLink={onClickLink}
    />
  );
};

export default ArtistDetailContainer;
